module.exports = __webpack_public_path__ + "static/media/success-nested-layer.e3115f96.png";